import {Box, BoxProps} from "@mui/joy";

import {mergeSx} from "../components/joyx.tsx";

export function HCBox({sx: inSx, children}: BoxProps) {
    const sx = mergeSx({
        flex: 0,
        display: "flex",
        flexDirection: "column",
        justifyItems: "center",
        alignItems: "center"
    }, inSx);
    return <Box sx={sx}>{children}</Box>
}
